// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1g3Fj","fileBtn":"File_fileBtn__toSYr","closeBtn":"File_closeBtn__3GZFq","fileSelected":"File_fileSelected__2heE9","disabled":"File_disabled__23YXm"};